import axios from 'axios';

const s3api = axios.create();

export default s3api;
